/**
 * ChargeAfter Consumer Financing Integration - Apply Now
 */

(function() {
  'use strict';
  
  function getConfig() {
    if (window.shopifyMetaobjects && window.shopifyMetaobjects.consumer_financing_config) {
      const config = window.shopifyMetaobjects.consumer_financing_config;
      const sandboxMode = config.sandbox_enabled ? config.sandbox_enabled.value : true;
      
      return {
        publicKey: sandboxMode 
          ? config.sandbox_public_key?.value 
          : config.production_public_key?.value,
        storeId: sandboxMode 
          ? config.sandbox_store_id?.value 
          : config.production_store_id?.value,
        environment: sandboxMode ? 'sandbox' : 'production'
      };
    }
    return null;
  }
  
  function setupApplyButton(config) {
    const button = document.querySelector('.chargeafter-apply-btn .btn') || 
                  document.querySelector('.chargeafter-apply-btn button') ||
                  document.querySelector('.chargeafter-apply-btn a') ||
                  Array.from(document.querySelectorAll('a, button, .btn')).find(el => 
                    el.textContent && el.textContent.toLowerCase().includes('apply now')
                  );
    
    if (!button) return;
    
    button.removeAttribute('disabled');
    button.style.cursor = 'pointer';
    button.style.pointerEvents = 'auto';
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (typeof ChargeAfter !== 'undefined' && ChargeAfter.payments && ChargeAfter.payments.present) {
        ChargeAfter.payments.present('apply', {
          preferences: { 
            language: 'En' 
          },
          currency: 'USD',
          ...(config.storeId && { storeId: config.storeId })
        });
      }
    });
  }
  
  function loadSDKAndInit() {
    const config = getConfig();
    if (!config || !config.publicKey) return;
    
    const sdkUrl = config.environment === 'production' 
      ? 'https://cdn.chargeafter.com/web/v2/chargeafter.min.js'
      : 'https://cdn-sandbox.ca-dev.co/web/v2/chargeafter.min.js';
      
    const script = document.createElement('script');
    script.src = sdkUrl;
    script.async = true;
    
    script.onload = function() {
      if (typeof ChargeAfter !== 'undefined' && ChargeAfter.init) {
        ChargeAfter.init({
          apiKey: config.publicKey,
          environment: config.environment,
          onLoaded: function() {
            setupApplyButton(config);
          }
        });
      }
    };
    
    document.head.appendChild(script);
  }
  
  function init() {
    if (getConfig()) {
      loadSDKAndInit();
    } else {
      setTimeout(init, 200);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
